import React from "react";
import { Box } from "@mui/material";

const IsoWeekIcon = ({ weekNumber }) => {
    const safeWeek = Number.isFinite(weekNumber) ? weekNumber : null;
    const weekLabel =
        safeWeek !== null ? String(safeWeek).padStart(2, "0") : "--";

    return (
        <Box
            sx={{
                width: 44,
                height: 44,
                borderRadius: 1.5,
                overflow: "hidden",
                border: 2,
                borderColor: "warning.main",
                textAlign: "center",
                bgcolor: "background.paper",
                boxShadow: 0,
                display: "flex",
                flexDirection: "column",
            }}
            aria-hidden
        >
            <Box
                sx={{
                    bgcolor: "warning.main",
                    color: "common.white",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                }}
            >
                Week
            </Box>
            <Box
                sx={{
                    color: "text.primary",
                    fontWeight: 700,
                    fontSize: "1rem",
                    lineHeight: 1,
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {weekLabel}
            </Box>
        </Box>
    );
};

export default IsoWeekIcon;
